import React, {Fragment} from "react";
import CommonHeader from "../../components/Headers/CommonHeader";
import SelectAlertType from "../../components/Modal/AddAlert";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/protectedContent";
import PageURLContextProvider from "../../contexts/pageURLContext";
import {useDisclosure} from "../../hooks/useDisclosure";
import AlertsTable from "./alertsTable";

const AlertsComponent = () => {
  const {isOpen, onOpen, onClose} = useDisclosure();

  return (
    <SafeView>
      <ProtectedContent perms={["view_alertdefinition"]} showFallback>
        <Fragment>
          <ProtectedContent perms={["add_alertdefinition"]}>
            <CommonHeader
              content={"Add Alert"}
              handleAddClick={onOpen}
              testID={"add_alert"}
            />
          </ProtectedContent>
          <SelectAlertType open={isOpen} onCloseHandler={onClose} />
          <AlertsTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const AlertsView = () => {
  return (
    <PageURLContextProvider>
      <AlertsComponent />
    </PageURLContextProvider>
  );
};

export default AlertsView;
